import { useSelfOnboardNavigation } from "~components/self-onboard/hooks/use-self-onboard-navigation"
import { useOutfitterContext } from "~contexts/outfitter-provider"
import { useUser } from "~contexts/user-provider"
import type { UpdateOutfitterInput } from "~graphql/generated/types"
import useOutfitter from "~utils/hooks/use-outfitter"
import { useUpdateOutfitter } from "~utils/hooks/use-update-outfitter"

export function useStepOutfitter() {
    const { isAdminNotImpersonating } = useUser()
    const {
        outfitter: persistedOutfitter,
        isLoading: isLoadingOutfitters,
        error: errorFromOutfittersQuery,
    } = useOutfitterContext()
    const {
        outfitter,
        isLoading: isLoadingOutfitter,
        error: errorFromOutfitterQuery,
    } = useOutfitter({
        id: persistedOutfitter?.id,
        fetchPolicy: "cache-first",
    })
    const isLoading = isLoadingOutfitter || isLoadingOutfitters
    const hasOutfitterIfNeeded = Boolean(outfitter) || isAdminNotImpersonating
    const isOutfitterLoading = isLoading && !hasOutfitterIfNeeded
    const error = errorFromOutfitterQuery ?? errorFromOutfittersQuery

    return { outfitter, isOutfitterLoading, error }
}

export function useUpdateOutfitterForStep({
    updatedSection,
}: {
    updatedSection: string
}) {
    const { outfitter, isOutfitterLoading, error } = useStepOutfitter()

    const { handleNextClick } = useSelfOnboardNavigation({
        isMainNavigation: false,
    })

    const { updateOutfitter: updateOutfitterMutation } = useUpdateOutfitter({
        outfitterId: outfitter?.id || "",
        onCompleted: () => {
            handleNextClick?.()
        },
        updatedSection,
        shouldShowSuccessToast: false,
    })

    const updateOutfitter = async (values: UpdateOutfitterInput) => {
        await updateOutfitterMutation({ data: values })
    }

    return {
        updateOutfitter,
        outfitter,
        isOutfitterLoading,
        error,
    }
}
